// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__VYgIi","timelineComp":"Timeline_timelineComp__QPbCr","ListItem":"Timeline_ListItem__uU0d5","text":"Timeline_text__-JDmN"};